import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';

// Help Center pages
import HelpCenter from './pages/help/HelpCenter';
import HelpGettingStarted from './pages/help/articles/getting-started';
import HelpFeatures from './pages/help/articles/features';
import HelpTroubleshooting from './pages/help/articles/troubleshooting';
import HelpAccount from './pages/help/articles/account';
import HelpIntegrations from './pages/help/articles/integrations';
import HelpCommunity from './pages/help/articles/community';
import HelpSupport from './pages/help/articles/support';
import HelpFAQ from './pages/help/articles/faq';
import HelpChangelog from './pages/help/articles/changelog';
// Individual article pages
import HelpWelcome from './pages/help/articles/getting-started/welcome';
import HelpFirstSplit from './pages/help/articles/getting-started/first-split';
import HelpAddingContacts from './pages/help/articles/getting-started/adding-contacts';
import HelpTopUpAccount from './pages/help/articles/getting-started/top-up-account';
import HelpCreateGroup from './pages/help/articles/getting-started/create-group';
import HelpManageGroup from './pages/help/articles/getting-started/manage-group';
import HelpTopUpGroup from './pages/help/articles/getting-started/top-up-group';
import HelpWithdrawGroup from './pages/help/articles/getting-started/withdraw-group';
import HelpLinkCardsWallets from './pages/help/articles/features/link-cards-wallets';
import HelpYourProfile from './pages/help/articles/features/your-profile';
import HelpBadgeCommunity from './pages/help/articles/features/badge-community';
import HelpSendP2P from './pages/help/articles/features/send-p2p';
import HelpRequestP2P from './pages/help/articles/features/request-p2p';
import HelpGasFees from './pages/help/articles/features/gas-fees';
import HelpRewards from './pages/help/articles/features/rewards';
import HelpGroups from './pages/help/articles/features/groups';
import HelpIntegration1 from './pages/help/articles/integrations/integration-1';
import HelpIntegration2 from './pages/help/articles/integrations/integration-2';
import HelpIntegration3 from './pages/help/articles/integrations/integration-3';
import HelpCommonIssues from './pages/help/articles/troubleshooting/common-issues';
import HelpPaymentProblems from './pages/help/articles/troubleshooting/payments';
import HelpAccountAccess from './pages/help/articles/troubleshooting/account-access';
import HelpProfile from './pages/help/articles/account/profile';
import HelpPrivacy from './pages/help/articles/account/privacy';
import HelpNotifications from './pages/help/articles/account/notifications';

/**
 * HelpApp Component
 * Handles routing for the help center subdomain (help.wesplit.io)
 * Only shows help center routes with clean URLs (no /help prefix)
 */
function HelpApp() {
  return (
    <Router>
      <div className="App">
        <Routes>
          {/* Root shows help center directly */}
          <Route path="/" element={<HelpCenter />} />
          
          {/* Clean Help Center routes (without /help prefix) */}
          <Route path="/getting-started" element={<HelpGettingStarted />} />
          <Route path="/features" element={<HelpFeatures />} />
          <Route path="/troubleshooting" element={<HelpTroubleshooting />} />
          <Route path="/account" element={<HelpAccount />} />
          <Route path="/integrations" element={<HelpIntegrations />} />
          <Route path="/community" element={<HelpCommunity />} />
          <Route path="/support" element={<HelpSupport />} />
          <Route path="/faq" element={<HelpFAQ />} />
          <Route path="/changelog" element={<HelpChangelog />} />
          {/* Individual article routes - Getting Started */}
          <Route path="/getting-started/welcome" element={<HelpWelcome />} />
          <Route path="/getting-started/first-split" element={<HelpFirstSplit />} />
          <Route path="/getting-started/adding-contacts" element={<HelpAddingContacts />} />
          <Route path="/getting-started/top-up-account" element={<HelpTopUpAccount />} />
          <Route path="/getting-started/create-group" element={<HelpCreateGroup />} />
          <Route path="/getting-started/manage-group" element={<HelpManageGroup />} />
          <Route path="/getting-started/top-up-group" element={<HelpTopUpGroup />} />
          <Route path="/getting-started/withdraw-group" element={<HelpWithdrawGroup />} />
          {/* Individual article routes - Features */}
          <Route path="/features/link-cards-wallets" element={<HelpLinkCardsWallets />} />
          <Route path="/features/your-profile" element={<HelpYourProfile />} />
          <Route path="/features/badge-community" element={<HelpBadgeCommunity />} />
          <Route path="/features/send-p2p" element={<HelpSendP2P />} />
          <Route path="/features/request-p2p" element={<HelpRequestP2P />} />
          <Route path="/features/gas-fees" element={<HelpGasFees />} />
          <Route path="/features/rewards" element={<HelpRewards />} />
          <Route path="/features/groups" element={<HelpGroups />} />
          {/* Individual article routes - Integrations */}
          <Route path="/integrations/integration-1" element={<HelpIntegration1 />} />
          <Route path="/integrations/integration-2" element={<HelpIntegration2 />} />
          <Route path="/integrations/integration-3" element={<HelpIntegration3 />} />
          {/* Individual article routes - Troubleshooting */}
          <Route path="/troubleshooting/common-issues" element={<HelpCommonIssues />} />
          <Route path="/troubleshooting/payments" element={<HelpPaymentProblems />} />
          <Route path="/troubleshooting/account-access" element={<HelpAccountAccess />} />
          {/* Individual article routes - Account */}
          <Route path="/account/profile" element={<HelpProfile />} />
          <Route path="/account/privacy" element={<HelpPrivacy />} />
          <Route path="/account/notifications" element={<HelpNotifications />} />
          
          {/* Legacy routes with /help prefix - redirect to clean URLs */}
          <Route path="/help" element={<Navigate to="/" replace />} />
          <Route path="/help/getting-started" element={<Navigate to="/getting-started" replace />} />
          <Route path="/help/features" element={<Navigate to="/features" replace />} />
          <Route path="/help/troubleshooting" element={<Navigate to="/troubleshooting" replace />} />
          <Route path="/help/account" element={<Navigate to="/account" replace />} />
          <Route path="/help/integrations" element={<Navigate to="/integrations" replace />} />
          <Route path="/help/community" element={<Navigate to="/community" replace />} />
          <Route path="/help/support" element={<Navigate to="/support" replace />} />
          <Route path="/help/faq" element={<Navigate to="/faq" replace />} />
          <Route path="/help/changelog" element={<Navigate to="/changelog" replace />} />
          <Route path="/help/getting-started/*" element={<Navigate to="/getting-started" replace />} />
          <Route path="/help/features/*" element={<Navigate to="/features" replace />} />
          <Route path="/help/integrations/*" element={<Navigate to="/integrations" replace />} />
          <Route path="/help/troubleshooting/*" element={<Navigate to="/troubleshooting" replace />} />
          <Route path="/help/account/*" element={<Navigate to="/account" replace />} />
          
          {/* Catch all - redirect to root (help center) */}
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </div>
    </Router>
  );
}

export default HelpApp;
